import {useState} from 'react';
import {AssetsSortersFE} from '../types/internal/tables/assetsTable';

export default function useAssetsSorters() {
  const [sorters, setSorters] = useState<AssetsSortersFE>({});
  
  function addSorters(addSorters: AssetsSortersFE) {
    setSorters({...sorters, ...addSorters});
  }
  
  function removeSorters(removeSorters: keyof AssetsSortersFE | (keyof AssetsSortersFE)[]) {
    const updatedSorters = {...sorters};
    
    if (Array.isArray(removeSorters)) {
      removeSorters.forEach(el => delete updatedSorters[el]);
    } else {
      delete updatedSorters[removeSorters];
    }
    
    setSorters(updatedSorters);
  }
  
  function resetSorters() {
    setSorters({});
  }
  
  return {
    sorters,
    addSorters,
    removeSorters,
    resetSorters,
  }
}